import { useTranslation } from 'react-i18next'

import { Tab } from 'components/Tabs'
import { generateSelector } from 'providers/product-fruits/utils'
import { BidParamsAndConnection } from '../../pages/BidParamsAndConnection'
import { GeneralPage } from '../../pages/GeneralPage'
import { BidderEditTabs } from './types'

export const useTabs = (): Tab<BidderEditTabs>[] => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'prebid.bidders.edit.tabs',
  })

  return [
    {
      element: 'general',
      label: t('general'),
      page: <GeneralPage />,
    },
    {
      element: 'bid-params-and-connection',
      label: t('bidParamsAndConnection'),
      page: <BidParamsAndConnection />,
      productFruitsSelector: generateSelector({ step: 7, subTour: 2, tour: 3 }),
    },
  ]
}
